import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SITE } from "../lib/site";

export default function Services() {
  return (
    <div data-testid="services-page" className="bg-[#0B0F0E]">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-20 md:pt-28 pb-16">
        <div className="overline"><span className="h-line" />Our services</div>
        <h1 className="font-display text-[#F4EFE6] text-6xl md:text-7xl lg:text-[5.5rem] mt-7 leading-[0.95] max-w-4xl">
          Comprehensive <span className="italic-gold">strategic land</span> &amp; planning expertise.
        </h1>
        <p className="text-[#9BA39B] text-lg max-w-3xl mt-9 leading-relaxed">
          From early-stage appraisal to consented disposal — across greenfield, brownfield, residential and commercial markets — every service is designed around one outcome: maximising the value of your land while removing the cost and risk from you.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pb-28 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="sticky top-32">
            <img src={SITE.images.planning} alt="Planning blueprint" className="w-full h-[560px] object-cover" />
            <div className="bg-[#C9A24B] text-[#0B0F0E] px-7 py-6 -mt-1">
              <div className="text-[10px] tracking-[0.28em] uppercase font-semibold">A trusted partner</div>
              <div className="font-display text-2xl mt-2">We invest at our cost. You share the uplift.</div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-7 divide-y divide-[#F4EFE6]/10">
          {SITE.services.map((s, i) => (
            <div key={s.key} data-testid={`service-${s.key}`} className="py-9 grid grid-cols-12 gap-4 group">
              <div className="col-span-2 font-display text-[#C9A24B]/60 text-2xl">0{i+1}</div>
              <div className="col-span-10">
                <h3 className="font-display text-3xl text-[#F4EFE6] group-hover:text-[#C9A24B] transition-colors">{s.title}</h3>
                <p className="text-[#9BA39B] mt-3 leading-relaxed max-w-2xl">{s.blurb}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Planning Expertise Grid */}
      <section className="bg-[#11171A] border-y border-[#F4EFE6]/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-28">
          <div className="grid lg:grid-cols-12 gap-12 mb-14">
            <div className="lg:col-span-7">
              <div className="overline"><span className="h-line" />Specialist capability</div>
              <h2 className="font-display text-[#F4EFE6] text-5xl md:text-6xl mt-6 leading-[0.95]">
                Every <span className="italic-gold">planning lever</span> pulled in your favour.
              </h2>
            </div>
            <div className="lg:col-span-5">
              <p className="text-[#9BA39B] leading-relaxed mt-3">
                We operate fluently across every part of the English planning system — and bring the same rigour to commercial floor-space cases as we do to residential allocations.
              </p>
            </div>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#F4EFE6]/10 border border-[#F4EFE6]/10">
            {SITE.expertise.map((e, i) => (
              <div key={e.t} data-testid={`services-expertise-${i}`} className="bg-[#11171A] p-7 card-lift">
                <div className="font-display text-[#C9A24B] text-2xl">0{i+1}</div>
                <div className="font-display text-xl text-[#F4EFE6] mt-3">{e.t}</div>
                <p className="text-[#9BA39B] text-sm mt-3 leading-relaxed">{e.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-28 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <div className="overline"><span className="h-line" />Talk to us</div>
            <h2 className="font-display text-[#F4EFE6] text-5xl md:text-6xl mt-6 max-w-2xl leading-[0.95]">
              Discuss your site with our team <span className="italic-gold">in confidence.</span>
            </h2>
          </div>
          <Link to="/sell-your-land" data-testid="services-cta" className="usl-btn">Submit Your Land <ArrowUpRight size={16} /></Link>
        </div>
      </section>
    </div>
  );
}
